<template>
  <div class="soleProp_h">
    <PageContent>
      <StepsV2 :step="2" />
      <PanelV2
        type="w6"
        title="Provide details about your online store"
        @nextClick="commitData()"
      >
        <template v-slot:title-solt>
          <BdoProgress  :step="3" :total="3" />
        </template>
        <template v-slot:content-solt>
          <OnlineStore
            ref="appForm"
          />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  // import AppForm from "../forms/SolePropH.val";
  import OnlineStore from "../components/OnlineStore.vue";
  import API from "@/api";

  export default {
    name: 'SolePropH',
    pRouter: 'SolePropG',
    components: {
      // AppForm,
      OnlineStore,
    },
    data() {
      return {
        formData: {},
      }
    },
    methods: {
      commitData() {

        const onlineStoreList = [];
        this.$refs.appForm.formData.onlineStoreList.filter((item) => {
          onlineStoreList.push(item);
        });

        this.$refs.appForm.$refs.formData.validate((valid) => {
          if (valid) {
              const OBJdata = this.formatCommitData({onlineStoreList})

              API.addBdoProcess({
                ...OBJdata
              }).then(res => {
                if (res.success) {
                  this.toNext()
                }
              })
            }
        });
      }
    }
  }
</script>


<style lang="scss" scoped>
.soleProp_h {
  ::v-deep .content {
    & > div {
      min-height: 298px;
    }
  }
}
</style>
